// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filter-option-input-wrapper{height:30px;width:316px}`, "",{"version":3,"sources":["webpack://./src/styles/components/filterOption.scss"],"names":[],"mappings":"AAAA,6BACE,WAAA,CACA,WAAA","sourcesContent":[".filter-option-input-wrapper {\n  height: 30px;\n  width: 316px; \n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
